// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"31b5e8b9","513":"7a6890b2","787":"195f9fb6"}[chunkId] + ".chunk.js";
};